<!-- Contact Component -->
<script>
  import { Col, Row, Container, FormGroup, Input } from "sveltestrap";
</script>

<!-- CONTACT FORM START-->
<section class="section common-section" id="contact">
  <Container>
    <Row>
      <Col lg={{ size: 8, offset: 2 }}>
        <h1 class="section-title text-center">Get In Touch</h1>
        <div class="section-title-border mt-3" />
        <p class="section-subtitle text-muted text-center font-secondary pt-4">
          Don't let distance stop us from connecting! Whether you're across the street or across the world, let's bridge the gap and stay connected.
        </p>
      </Col>
    </Row>
    <Row>
      <Col lg="4">
        <div class="mt-4 pt-4">
          <p class="mt-4">
            <span class="h5">Address</span><br />
            <span class="text-muted d-block mt-2"
              >Buddhanagar, New Baneshwor</span
            >
          </p>
          <!-- <p class="mt-4">
            <span class="h5">Office Address 2:</span><br />
            <span class="text-muted d-block mt-2"
              >2467 Swick Hill Street <br />New Orleans, LA 70171</span
            >
          </p> -->
          <p class="mt-4">
            <span class="h5">Working Hours:</span><br />
            <span class="text-muted d-block mt-2">9:00AM To 6:00PM</span>
          </p>
        </div>
      </Col>
      <Col lg="8">
        <div class="custom-form mt-4 pt-4">
          <form method="post" name="myForm" onsubmit="return validateForm()">
            <p id="error-msg" />
            <div id="simple-msg" />
            <Row>
              <Col lg="6">
                <FormGroup class="mt-2">
                  <Input
                    name="name"
                    id="name"
                    type="text"
                    class="form-control"
                    placeholder="Your name*"
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup class="mt-2">
                  <Input
                    name="email"
                    id="email"
                    type="email"
                    class="form-control"
                    placeholder="Your email*"
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg="12">
                <FormGroup class="mt-2">
                  <Input
                    type="text"
                    class="form-control"
                    id="subject"
                    name="subject"
                    placeholder="Your Subject.."
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg="12">
                <FormGroup class="mt-2">
                  <Input
                    type="textarea"
                    name="comments"
                    id="comments"
                    rows="4"
                    class="form-control"
                    placeholder="Your message..."
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg="12" class="text-end">
                <Input
                  type="submit"
                  id="submit"
                  name="send"
                  class="submitBnt btn btn-primary"
                  value="Send Message"
                />
              </Col>
            </Row>
          </form>
        </div>
      </Col>
    </Row>
  </Container>
</section>
<!-- CONTACT FORM END-->

<!--START SOCIAL-->
<section class="contact-social bg-light">
  <Container>
    <Row class="align-items-center">
      <Col lg="6">
        <ul class="list-inline social mt-4">
          <li class="list-inline-item">
            <a href={"https://www.facebook.com/kritanp77"} class="social-icon"><i class="mdi mdi-facebook" /></a>
          </li>
          <li class="list-inline-item">
            <a href={"https://www.instagram.com/kritan_pandey/"} class="social-icon"><i class="mdi mdi-instagram" /></a>
          </li>
          <li class="list-inline-item">
            <a href={"https://www.linkedin.com/in/kritanpandey7/"} class="social-icon"><i class="mdi mdi-linkedin" /></a>
          </li>
          <li class="list-inline-item">
            <a href={"https://www.youtube.com/@kritan55"} class="social-icon"
              ><i class="mdi mdi-youtube" /></a
            >
          </li>
          <!-- <li class="list-inline-item">
            <a href={"#"} class="social-icon"><i class="mdi mdi-dribbble" /></a>
          </li> -->
        </ul>
      </Col>
      <Col lg="3" class="mt-4">
        <p class="contact-title">
          <i class="pe-7s-call" /> &nbsp;+977 9808750151
        </p>
      </Col>
      <Col lg="3" class="mt-4 text-end">
        <p class="contact-title">
          <i class="pe-7s-mail-open" />&nbsp; itsmekritan@gmail.com
        </p>
      </Col>
    </Row>
  </Container>
</section>
<!--END SOCIAL-->
